module.exports = __webpack_public_path__ + "img/cart-buy.5e0d92c4.png";